import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmDatepickerModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class BatchesMetaModel extends FormMetaModel {
    constructor() {
        super('Add Batch', ROUTE_PATH.batchesGrid, ROUTE_PATH.addBatches, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const batch_number = new SmMetaInputModel(
            'batch_number',
            'batch_number',
            'input',
            true,
            'col-12 col-md-4 ',
            1,
            1,
            'Batch Number',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Batch Number"
        );
        const duration_start = new SmDatepickerModel(
            'duration_start',
            'duration_start',
            'datepicker',
            true,
            'col-12 col-md-4 mb-2',
            1,
            2,
            'Batch Start',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );


        const duration_end = new SmDatepickerModel(
            'duration_end',
            'duration_end',
            'datepicker',
            true,
            'col-12 col-md-4 mb-2',
            1,
            3,
            'Batch End',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );

        

        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            batch_number,
            duration_start,
            duration_end

        }
    }
}